import { render, staticRenderFns } from "./single.vue?vue&type=template&id=290e50fb&scoped=true&lang=pug&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e50fb",
  null
  
)

export default component.exports